import { Injectable } from '@angular/core';
import { HttpHelperService } from './helper/http/http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
public userInfo:any={};
public IslogedIn:boolean=false;
public userName:string='';
public userRole:string;
  constructor(private httpClientService: HttpHelperService) { }

  login(data:any){
    this.httpClientService.postRequest('api/auth/login',data)
    .subscribe((response)=>{
      localStorage.setItem('accessToken',response.accessToken);
      localStorage.setItem('refreshToken',response.refreshToken);
    });
  }
  setUserInfo(data:any){
    console.log("data!!",data);
    this.IslogedIn=true;
    this.userInfo=data.userProfile;
    this.userName=this.userInfo.firstName +''+ this.userInfo.lastName;
    this.userRole = data.roles;
    sessionStorage.setItem("userInfo",JSON.stringify(data.userProfile));
    sessionStorage.setItem("loggedInUserId",JSON.stringify(data.userProfile?.id));
    sessionStorage.setItem("userRole",JSON.stringify(data.roles))
  }
  getUserInfo(){
    if(sessionStorage.getItem("userInfo")){
      this.userInfo=JSON.parse(sessionStorage.getItem("userInfo"));
      this.IslogedIn=true;
      this.userName=this.userInfo.firstName +'  '+ this.userInfo.lastName;
      return this.userInfo;
    }
    else{return false;}
  }
  getUserRole(){
    this.userRole = JSON.parse(sessionStorage.getItem("userRole"));
    return this.userRole;
  }
}
